/*
 *
 */
const getNiceHourAndMin = (h = 0, m = 0): string => {
	if (h === 0 && m === 0) return '0';
	let out = '';
	if (h > 0) {
		out += `${h} hour`;
		if (h > 1) out += 's';
	}
	if (h > 0 && m > 0) out += ' and ';
	if (m > 0) {
		out += `${m} minute`;
		if (m > 1) out += 's';
	}
	return out;
};

export function formatDecimalTime(decimalTime: number): string {
	const hours = Math.floor(decimalTime); // Extracts the whole number of hours
	const minutes = Math.round((decimalTime - hours) * 60); // Converts the decimal part to minutes
	return getNiceHourAndMin(hours, minutes);
}
